/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-20 21:36:15
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import { Integer } from 'src/types/base';
import AlarmSearchApi from './api/alarmSearchApi';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';

export namespace NoticeVOI {
    export interface PropsI {
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        mobiles: string[];
        inform_content: string;
        userIds: Integer[],
    }
}

@Component
class NoticeModal extends Vue.Component<NoticeVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: NoticeVOI.FormDataI = {
        mobiles: [],
        inform_content: '',
        userIds: [],
    };
    rules: any = {
        mobiles: [{ required: true, message: '请输入手机号', trigger: 'change' }],
        inform_content: [{ required: true, message: '请输入内容', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params = {
            ...this.formData,
            mobiles: this.formData.userIds.map(i=> {
                let user:any = (this.$refs.entitySelect as EntitySelect).getSourceData().find(sub=> i=== sub.id);
                return user.mobile
            }),
            id:this.id
        };
        res = await AlarmSearchApi.notice(params)
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success('通知成功');
            this.saveSuccess();
            this.closeModal();
        }
    }

    render(h) {
        return (
            <Modal class-name="wqms-data-complete-modal" title="报警通知" width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                {/*<form-item label="通知手机号" prop="mobiles">
                        <Input v-model={this.formData.mobiles} placeholder="请输入多个手机号，逗号分隔" type="textarea" autosize={{ minRows: 3 }}/>
                     </form-item>*/}    
                    <form-item label="通知手机号" prop="userIds" style="display: inline-block;width: 280px;margin-bottom: 5px;" required type='array'>
                       <EntitySelect ref="entitySelect" type={EnumEntity.User.getId()} v-model={this.formData.userIds} multiple ></EntitySelect>
                    </form-item>
                    <form-item label="通知内容" prop="inform_content">
                        <Input v-model={this.formData.inform_content} placeholder="请输入" type="textarea" autosize={{ minRows: 3 }} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertNoticeModal(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<NoticeVOI.PropsI>(NoticeModal)({
            id,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
